module.exports = __webpack_public_path__ + "img/pro.32b4d11e.png";